import React from 'react'

/**
 * Vector rebuild of the Aldaron mark (public/logo.jpeg): three connected nodes
 * forming an "A", with a growth arrow breaking out of the crossbar.
 * Drawn in currentColor so it sits on navy or white without a second asset.
 */
export const LogoMark = ({ className = 'h-9 w-9' }) => (
  <svg viewBox="0 0 120 120" className={className} aria-hidden="true" fill="none">
    <g stroke="currentColor" strokeLinecap="round" strokeWidth="13">
      {/* left leg of the A */}
      <path d="M45 38 30 80" />
      {/* right leg of the A */}
      <path d="M57 36 78 72" />
      {/* crossbar, tapering up to the right */}
      <path d="M34 78 66 55" />
    </g>
    {/* nodes */}
    <g fill="currentColor">
      <circle cx="49" cy="27" r="14" />
      <circle cx="26" cy="87" r="14" />
      <circle cx="83" cy="80" r="12" />
      {/* breakout arrow */}
      <path d="M74 47 106 33 96 64 89 53 79 59z" />
    </g>
  </svg>
)

export const Wordmark = ({ className = '', markClass = 'h-9 w-9', tone = 'dark' }) => (
  <span className={`inline-flex items-center gap-3 ${className}`}>
    <LogoMark className={`${markClass} ${tone === 'light' ? 'text-white' : 'text-navy-900'}`} />
    <span className="flex flex-col leading-none">
      <span
        className={`font-display text-lg font-extrabold tracking-[0.12em] ${
          tone === 'light' ? 'text-white' : 'text-navy-900'
        }`}
      >
        ALDARON
      </span>
      <span
        className={`mt-1 font-display text-[0.6rem] font-semibold uppercase tracking-[0.18em] ${
          tone === 'light' ? 'text-brand-300' : 'text-brand-600'
        }`}
      >
        Innovate. Empower. Deliver.
      </span>
    </span>
  </span>
)

export default LogoMark
